import PAUSE_TASK_REASON from 'FielderUtils/task/pauseTaskReason';
import REJECT_TASK_REASON from 'FielderUtils/task/rejectTaskReason';

import ANALITICS_SECTIONS from './AnaliticsSectionsConst';

export const analiticsMenuOptions = (lan) => [
	{
		title: lan.dashboardAnalitycs,
		value: ANALITICS_SECTIONS.DASHBOARD_SECTION,
	},
	{
		title: lan.dashboardAnalitycsTask,
		value: ANALITICS_SECTIONS.TASK_SECTION,
		children: [
			{
				title: lan.dashboardPausedTasks,
				value: ANALITICS_SECTIONS.TASK_PAUSE_SECTION,
			},
			{
				title: lan.dashboardRejectedTasks,
				value: ANALITICS_SECTIONS.TASK_REJECT_SECTION,
			},
		],
	},
	{
		title: lan.dashboardAnalitycsGroup,
		value: ANALITICS_SECTIONS.GROUP_SECTION,
	},
	{
		title: lan.dashboardAnalitycsAgent,
		value: ANALITICS_SECTIONS.AGENT_SECTION,
	},
	{
		title: lan.dashboardAnalitycsClient,
		value: ANALITICS_SECTIONS.CLIENT_SECTION,
	},
	{
		title: lan.dashboardAnalitycsBranch,
		value: ANALITICS_SECTIONS.BRANCH_SECTION,
	},
	{
		title: lan.dashboardAnalitycsCompany,
		value: ANALITICS_SECTIONS.COMPANY_SECTION,
	},
	{
		title: lan.dashboardAnalitycsPartner,
		value: ANALITICS_SECTIONS.MY_PARTNER_SECTION,
	},
	{
		title: lan.dashboardAnalitycsIPartner,
		value: ANALITICS_SECTIONS.IAM_PARTNER_SECTION,
	},
];

export const defaultTypeTasks = (lan) => [
	{
		id: 1,
		name: lan.pickup,
		children: [],
		title: lan.pickup,
		value: 1,
		key: 1,
	},
	{
		id: 2,
		name: lan.workforce,
		children: [],
		title: lan.workforce,
		value: 2,
		key: 2,
	},
	{
		id: 3,
		name: lan.delivery,
		children: [],
		title: lan.delivery,
		value: 3,
		key: 3,
	},
	{
		id: 4,
		name: lan.tasktypeAll,
		children: [],
		title: lan.tasktypeAll,
		value: -1,
		key: 4,
	},
];

export const setRejectReasons = (lan, rejectReasons) => {
	const rowsTablePause = [];
	rejectReasons.forEach((reason) => {
		let parentName = lan.pausedByAgent;
		if (reason.parentReason === REJECT_TASK_REASON.REJECT_BY_FINAL_CLIENT) {
			parentName = lan.pausedByFinalClient;
		}

		rowsTablePause.push({
			title: `${parentName} / ${reason.reasonName}`,
			value: reason.idRejectTaskReason,
		});
	});

	rowsTablePause.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	return rowsTablePause;
};

export const setRejectReasonsByParent = (lan, rejectReasons) => {
	const rowsTableRejectAgent = [];
	const rowsTableRejectClient = [];

	rejectReasons.forEach((reason) => {
		if (reason.parentReason === REJECT_TASK_REASON.REJECT_BY_FINAL_CLIENT) {
			rowsTableRejectClient.push({
				title: reason.reasonName,
				value: reason.idRejectTaskReason,
			});
		} else {
			rowsTableRejectAgent.push({
				title: reason.reasonName,
				value: reason.idRejectTaskReason,
			});
		}
	});

	rowsTableRejectAgent.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	rowsTableRejectClient.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	return { rowsTableRejectAgent, rowsTableRejectClient };
};

export const setPauseReasons = (lan, pauseReasons) => {
	const rowsTablePause = [];
	pauseReasons.forEach((reason) => {
		let parentName = lan.pausedByAgent;
		if (reason.parentReason === PAUSE_TASK_REASON.REJECT_BY_FINAL_CLIENT) {
			parentName = lan.pausedByFinalClient;
		}

		rowsTablePause.push({
			title: `${parentName} / ${reason.reasonName}`,
			value: reason.idPauseTaskReason,
		});
	});

	rowsTablePause.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	return rowsTablePause;
};

export const setPauseReasonsByParent = (lan, pauseReasons) => {
	const rowsTablePauseAgent = [];
	const rowsTablePauseClient = [];

	pauseReasons.forEach((reason) => {
		if (reason.parentReason === PAUSE_TASK_REASON.PAUSED_BY_FINAL_CLIENT) {
			rowsTablePauseClient.push({
				title: reason.reasonName,
				value: reason.idPauseTaskReason,
			});
		} else {
			rowsTablePauseAgent.push({
				title: reason.reasonName,
				value: reason.idPauseTaskReason,
			});
		}
	});

	rowsTablePauseAgent.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	rowsTablePauseClient.push({
		title: lan.tasktypeAll,
		value: -1,
	});

	return { rowsTablePauseAgent, rowsTablePauseClient };
};
